// Toast Yapılandırması
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const centerToast = Swal.mixin({
  position: "center",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  icon: "success",
});

function showCenterToast(message) {
  centerToast.fire({
    title: message,
  });
}

function showToast(type, message) {
  Toast.fire({
    icon: type,
    title: message,
  });
}

// 📌 Yeni eklenen Wand'ların inputlarına validasyon eventlerini bağlar
function bindValidationEventsToInputs(wand) {
  wand.querySelectorAll(".breedte, .hoogte").forEach((input) => {
    input.addEventListener("blur", function () {
      validateInput(this);
    });
  });
}

// **Breedte ve Hoogte için validasyon fonksiyonu**
function validateInput(inputElement) {
  const value = parseInt(inputElement.value, 10);
  const id = inputElement.id;
  let min, max, message;
  if (!value) {
    return;
  }
  if (id.includes("breedte")) {
    min = 1500;
    max = 7000;
    message = `Breedte moet tussen ${min} en ${max} mm zijn.`;
  } else if (id.includes("hoogte")) {
    min = 1970;
    max = 2700;
    message = `Hoogte moet tussen ${min} en ${max} mm zijn.`;
  }

  if (value < min || value > max || isNaN(value)) {
    showErrorMessage(inputElement, message);
    inputElement.value = ""; // Hatalı giriş varsa sıfırla
  } else {
    removeErrorMessage(inputElement);
  }
}

// **Hata mesajını input'un hemen altında gösterme fonksiyonu**
function showErrorMessage(inputElement, message) {
  removeErrorMessage(inputElement); // Önce varsa eski hata mesajını kaldır

  const errorDiv = document.createElement("div");
  errorDiv.classList.add("input-error-message");
  errorDiv.textContent = message;

  inputElement.parentNode.appendChild(errorDiv); // Input'un altına ekle

  // 4 saniye sonra hata mesajını kaldır
  setTimeout(() => {
    removeErrorMessage(inputElement);
  }, 4000);
}

// **Hata mesajını kaldırma fonksiyonu**
function removeErrorMessage(inputElement) {
  const existingError = inputElement.parentNode.querySelector(
    ".input-error-message"
  );
  if (existingError) {
    existingError.remove();
  }
}

function formatPrice(price) {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  })
    .format(price)
    .replace("€", "€ ");
}

function getTochtstripCount(productName) {
  if (productName.includes("7x")) {
    return 6;
  } else if (productName.includes("6x")) {
    return 5;
  } else if (productName.includes("5x")) {
    return 4;
  } else if (productName.includes("4x")) {
    return 3;
  } else if (productName.includes("3x")) {
    return 2;
  } else if (productName.includes("2x")) {
    return 1;
  }
  return 0; // Eğer ray bilgisi yoksa varsayılan 0 yap
}

function getHoogteRange(hoogteMm) {
  const hoogteCm = Math.floor(hoogteMm / 10);

  if (hoogteCm >= 197 && hoogteCm <= 201) return "min. 197 cm / max. 201 cm";
  if (hoogteCm >= 202 && hoogteCm <= 206) return "min. 202 cm / max. 206 cm";
  if (hoogteCm >= 207 && hoogteCm <= 211) return "min. 207 cm / max. 211 cm";
  if (hoogteCm >= 212 && hoogteCm <= 216) return "min. 212 cm / max. 216 cm";
  if (hoogteCm >= 217 && hoogteCm <= 221) return "min. 217 cm / max. 221 cm";
  if (hoogteCm >= 222 && hoogteCm <= 226) return "min. 222 cm / max. 226 cm";
  if (hoogteCm >= 227 && hoogteCm <= 231) return "min. 227 cm / max. 231 cm";
  if (hoogteCm >= 232 && hoogteCm <= 236) return "min. 232 cm / max. 236 cm";
  if (hoogteCm >= 237 && hoogteCm <= 241) return "min. 237 cm / max. 241 cm";
  if (hoogteCm >= 242 && hoogteCm <= 246) return "min. 242 cm / max. 246 cm";
  if (hoogteCm >= 247 && hoogteCm <= 251) return "min. 247 cm / max. 251 cm";
  if (hoogteCm >= 252 && hoogteCm <= 256) return "min. 252 cm / max. 256 cm";
  if (hoogteCm >= 257 && hoogteCm <= 261) return "min. 257 cm / max. 261 cm";
  if (hoogteCm >= 262 && hoogteCm <= 266) return "min. 262 cm / max. 266 cm";
  if (hoogteCm >= 267 && hoogteCm <= 270) return "min. 267 cm / max. 270 cm";

  return "min. xxx cm / max. xxx cm"; // Eğer uygun aralık yoksa.
}

/******  e54bc09b-1f72-4275-a410-6fbc6fe51f2c  *******/
function animateText(element, startDelay) {
  const text = element.textContent.trim(); // Boşlukları koru
  element.innerHTML = ""; // Metni temizle

  text.split("").forEach((char, index) => {
    const span = document.createElement("span");
    span.textContent = char === " " ? "\u00A0" : char; // Boşlukları koru
    span.style.animationDelay = `${startDelay + index * 0.1}s`; // Gecikme süresi
    element.appendChild(span);
  });
}

// RAL bilgisinden rengi dönüştürme fonksiyonu
function getColorNameFromRAL(ralValue) {
  switch (ralValue) {
    case "Antraciet":
      return "Antraciet (RAL7016)";
    case "Creme":
      return "Creme (RAL9001)";
    case "Wit":
      return "Wit (RAL9010)";
    case "Zwart":
      return "Zwart (RAL9005)";
    default:
      return "-"; // Varsayılan değer
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const wandContainer = document.getElementById("wand-container");
  const addWandButton = document.getElementById("add-wand-button");
  // const defaultImage = document.getElementById("default-image");
  const contentContainer = document.getElementById("content-container");
  const onImageText = document.getElementById("cs-onimage");
  const overzichtContainer = document.getElementById("overzicht-container");
  const overzichtContent = document.getElementById("overzicht-content");
  const bestellenButton = document.getElementById("bestellen-button");
  const bestellenButtonCont = document.getElementById("bes-btn-cont");
  const logoContainer = document.getElementById("logo-container");

  // İlk başlık animasyonu
  // const animatedTitle = document.getElementById("animated-title");
  // animateText(animatedTitle, 0); // Hemen başlasın

  // Alt başlık animasyonu
  // const animatedBottomTitle = document.getElementById("animated-bottom-title");
  // animateText(animatedBottomTitle, 1.5); // 1.5 saniye gecikmeyle başlasın

  document.querySelectorAll(".breedte, .hoogte").forEach((input) => {
    input.addEventListener("blur", function () {
      validateInput(this);
    });
  });

  // Başlangıçtaki Overzicht'i hazırla
  function initializeOverzicht() {
    updateOverzicht();
  }

  // Ürün bulma fonksiyonu
  function findProduct(breedte, hoogte, glasType, color) {
    return productsLinkData.find((product) => {
      return (
        breedte >= product.min &&
        breedte <= product.max &&
        hoogte >= 1970 &&
        hoogte <= 2700 &&
        color !== "-" &&
        product.variants[glasType]
      );
    });
  }

  document.addEventListener("focusin", (e) => {
    if (e.target.closest(".cs-dimensions")) {
      document
        .querySelectorAll(".cs-dimensions")
        .forEach((wand) => wand.classList.remove("active"));
      e.target.closest(".cs-dimensions").classList.add("active");
      userStartedTyping = true;
    }
  });

  // Overzicht Güncelleme
  function updateOverzicht() {
    const dynamicContent = overzichtContent.querySelector(".dynamic-content"); // Dinamik içerik alanını seç
    if (!dynamicContent) {
      // Eğer dinamik içerik alanı yoksa, oluştur
      const newDynamicContent = document.createElement("div");
      newDynamicContent.classList.add("dynamic-content");
      overzichtContent.insertBefore(
        newDynamicContent,
        overzichtContent.firstChild
      );
    }

    const dynamicContentArea =
      overzichtContent.querySelector(".dynamic-content");
    dynamicContentArea.innerHTML = ""; // Sadece dinamik içeriği temizle

    let totalPrice = 0;
    let anyProductFound = false;
    let activeWandHasProduct = false; // 📌 Aktif wand için ürün bulundu mu?

    // Her bir Wand öğesini işleme al
    document.querySelectorAll(".cs-dimensions").forEach((wand, index) => {
      const breedte = wand.querySelector(`#breedte-${index + 1}`)?.value || "-";
      const hoogte = wand.querySelector(`#hoogte-${index + 1}`)?.value || "-";
      const glasType =
        wand.querySelector(`#glas-type-${index + 1}`)?.value || "-";
      const colorRal = wand.querySelector(`#color-${index + 1}`)?.value || "-";
      const color = colorRal; // RAL'den rengi dönüştür
      let price = 0;
      const product = findProduct(breedte, hoogte, glasType, color);

      if (product) {
        const variantId = product.variants[glasType]?.variantIds[color]; // Variant ID'yi belirle
        if (variantId) {
          wand.setAttribute("data-variant", variantId); // Variant ID'yi ata
        }

        price = product.variants[glasType]?.price || 0;
        // showToast("success", `Product gevonden voor Schuifwand ${index + 1}`);
        wand.setAttribute("data-product", "true");
        anyProductFound = true; // Ürün bulunduğunda flag'i true yap

        // 📌 Eğer aktif wand ise ve ürün bulunduysa flag'i true yap
        if (wand.classList.contains("active")) {
          activeWandHasProduct = true;
        }
      } else {
        wand.setAttribute("data-product", "false");
        wand.removeAttribute("data-variant"); // Ürün bulunamadığında data-variant'ı kaldır
      }

      totalPrice += price;

      const overzichtItem = `
        <div class="offer-item">
          <div class="offer-item-title">
            <div class="offer-heading">Glazen schuifwand ${index + 1}</div>
            <div class="offer-price">${formatPrice(price)}</div>
          </div>
          <div class="offer-item-content">
            <div class="offer-label">Afmetingen:</div>
            <div class="offer-detail">${breedte} mm breed x ${hoogte} mm hoog <small style="font-size: 11px"> (marge: ${getHoogteRange(
        hoogte
      )})</small></div>
            
            <div class="offer-label">Glaspanelen:</div>
            <div class="offer-detail">${
              product?.glazen ? `${product.glazen} breedte` : ""
            }</div>
            
            <div class="offer-label">Type Glas:</div>
            <div class="offer-detail">${
              glasType && glasType !== "-" ? `${glasType} glas` : ""
            }</div>
            
            <div class="offer-label">Kleur Rails:</div>
            <div class="offer-detail">${
              color && color !== "-" ? getColorNameFromRAL(colorRal) : ""
            }</div>
       
            <div class="offer-label">Accessoires:</div>
            <div class="offer-detail">
              ${
                product
                  ? `1 x set opvangsprofielen, ${getTochtstripCount(
                      product.name
                    )} x tochtstrippen en 2 x handvatten`
                  : ""
              }
            </div>
          </div>
        </div>`;
      dynamicContentArea.insertAdjacentHTML("beforeend", overzichtItem);
    });

    if (
      activeWandHasProduct &&
      document
        .querySelector(".cs-dimensions.active")
        .getAttribute("data-product") === "true" &&
      window.innerWidth < 800 // ✅ Ekran genişliği 800px’den küçükse scroll yap
    ) {
      const targetElement = document.querySelector("#overzicht-container");
      const yOffset = -50; // 📌 50px yukarıda durmasını sağla, çok yukarı gitmesin
      const y =
        targetElement.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }

    // Eğer herhangi bir ürün bulunursa Bestellen butonunu göster, aksi takdirde gizle
    if (anyProductFound) {
      bestellenButtonCont.style.display = "flex";
    } else {
      bestellenButtonCont.style.display = "none";
    }

    // Toplam fiyatı güncelle
    const totalPriceElement = document.querySelector(".total-right");
    if (totalPriceElement) {
      totalPriceElement.textContent = formatPrice(totalPrice);
    }
  }

  // Overzicht'i göster
  async function showOverzicht() {
    hasStartedInput = true;
    // Varsayılan resmi gizle
    overzichtContainer.classList.add("show");
    contentContainer.classList.remove("hidden");
    onImageText.classList.add("hidden");
    logoContainer.classList.remove("hidden");
  }

  // Wand Ekle
  function addWand() {
    const allWands = document.querySelectorAll(".cs-dimensions");
    const ids = Array.from(allWands).map((wand) =>
      parseInt(wand.getAttribute("data-id"), 10)
    );
    const newId = ids.length > 0 ? Math.max(...ids) + 1 : 1;

    const wandHTML = `
      <div class="cs-dimensions" data-id="${newId}">
        <div class="wand-title">Schuifwand ${newId}:</div>
        <div class="cs-form-group">
          <div class="cs-input-group cs-select-cont">
            <select id="glas-type-${newId}" class="cs-select">
              <option value="" selected>Glas Type</option>
              <option value="Helder">Helder glas</option>
              <option value="Getint">Getint glas</option>
            </select>
          </div>
          <div class="cs-input-group cs-input-cont">
            <input type="number" id="breedte-${newId}" class="cs-input breedte" placeholder="Breedte (mm)" min="1500" max="7000" />
          </div>
          <div class="cs-input-group cs-input-cont">
            <input type="number" id="hoogte-${newId}" class="cs-input hoogte" placeholder="Hoogte (mm)" min="1970" max="2700" />
          </div>
          <div class="cs-input-group cs-select-cont kleur">
            <select id="color-${newId}" class="cs-select">
              <option value="" selected>Kleur Rails</option>
              <option value="Antraciet">Antraciet</option>
              <option value="Creme">Creme</option>
              <option value="Wit">Wit</option>
              <option value="Zwart">Zwart</option>
            </select>
          </div>
           <button class="remove-button">X</button>
        </div>

      </div>`;
    wandContainer.insertAdjacentHTML("beforeend", wandHTML);

    const newWand = document.querySelector(
      `.cs-dimensions[data-id="${newId}"]`
    );

    // 📌 Önce diğer wand'lardan "active" class'ını kaldır
    document
      .querySelectorAll(".cs-dimensions")
      .forEach((wand) => wand.classList.remove("active"));

    // 📌 Yeni eklenen wand'a "active" class'ı ekle
    newWand.classList.add("active");
    bindValidationEventsToInputs(newWand);

    updateOverzicht();
  }

  // Wand'ları yeniden numaralandırma fonksiyonu
  function renumberWands() {
    const allWands = document.querySelectorAll(".cs-dimensions");
    allWands.forEach((wand, index) => {
      const newId = index + 1; // 1'den başlat

      // data-id değerini güncelle
      wand.setAttribute("data-id", newId);

      // Başlığı güncelle
      const titleElement = wand.querySelector(".wand-title");
      if (titleElement) {
        titleElement.textContent = `Schuifwand ${newId}:`;
      }

      // ID'leri güncelle
      if (wand.querySelector(".cs-input.breedte")) {
        wand.querySelector(".cs-input.breedte").id = `breedte-${newId}`;
      }
      if (wand.querySelector(".cs-input.hoogte")) {
        wand.querySelector(".cs-input.hoogte").id = `hoogte-${newId}`;
      }
      if (wand.querySelector(".cs-select")) {
        wand.querySelector(".cs-select").id = `glas-type-${newId}`;
      }
      if (wand.querySelector(".kleur .cs-select")) {
        wand.querySelector(".kleur .cs-select").id = `color-${newId}`;
      }
    });
  }

  // Wand Sil
  wandContainer.addEventListener("click", (e) => {
    if (e.target.classList.contains("remove-button")) {
      const wand = e.target.closest(".cs-dimensions");
      wand.remove();
      renumberWands();
      updateOverzicht();
    }
  });

  // Aktivasyon Sistemini Ekleyelim
  function activateDimension(clickedElement) {
    document
      .querySelectorAll(".cs-dimensions .cs-input-group")
      .forEach((group) => {
        group.classList.remove("active");
      });

    const parentDimension = clickedElement.closest(".cs-dimensions");
    parentDimension.querySelectorAll(".cs-input-group").forEach((group) => {
      group.classList.add("active");
    });
  }

  wandContainer.addEventListener("focusin", (e) => {
    if (
      e.target.classList.contains("cs-input") ||
      e.target.classList.contains("cs-select")
    ) {
      activateDimension(e.target);
      showOverzicht(); // Overzicht'i göster
    }
  });

  // Event Listeners
  addWandButton.addEventListener("click", addWand);
  wandContainer.addEventListener("input", updateOverzicht);
  bestellenButton.addEventListener("click", () => {
    const wandItems = document.querySelectorAll(".cs-dimensions");
    const itemsToAdd = []; // Sepete eklenecek ürünler için liste

    // Her bir Schuifwand için ürün kontrolü yap
    wandItems.forEach((wand, index) => {
      const productFound = wand.getAttribute("data-product") === "true"; // Ürün bulunup bulunmadığını kontrol et
      const variantId = wand.getAttribute("data-variant"); // Variant ID'yi al
      const breedteInput =
        wand.querySelector(`#breedte-${index + 1}`)?.value || "-";
      const hoogteInput =
        wand.querySelector(`#hoogte-${index + 1}`)?.value || "-";

      if (
        productFound &&
        variantId &&
        breedteInput !== "-" &&
        hoogteInput !== "-"
      ) {
        itemsToAdd.push({
          variantId: variantId, // Variant ID
          hoogte: hoogteInput, // Hoogte değeri
          breedte: breedteInput, // Breedte değeri
        });
      }
    });

    // Eğer sepete eklenebilecek ürün varsa, addToCart fonksiyonunu çağır
    if (itemsToAdd.length > 0) {
      addToCart(itemsToAdd);
    } else {
      showToast("warning", "Geen producten gevonden om te bestellen!");
    }
  });

  // Eski addToCart Fonksiyonunun Uyarlanmış Hali
  async function addToCart(items, quantity = 1) {
    const checkoutUrl = "/cart/add.js"; // Shopify sepetine ürün eklemek için URL

    try {
      // Sepete eklenecek tüm ürünleri tek bir request ile gönderiyoruz
      const response = await fetch(checkoutUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: items.map((item) => ({
            id: item.variantId, // Variant ID
            quantity: quantity, // Ürün adedi
            properties: {
              hoogte: item.hoogte, // Hoogte değeri
              breedte: item.breedte, // Breedte değeri
            },
          })),
        }),
      });

      if (response.ok) {
        // Sepete başarıyla ekleme yapıldı
        const data = await response.json();
        console.log("Sepete ürünler eklendi:", data);
        showCenterToast("U wordt doorgestuurd naar de bestelpagina...");
        setTimeout(() => {
          window.location.href = "/cart"; // Kullanıcıyı sepet sayfasına yönlendir
        }, 2000);
      } else {
        // Hata durumunda
        showToast("error", "Something went wrong, please try again.");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      showToast("error", "Something went wrong, please try again.");
    }
  }

  initializeOverzicht();


  // promotie banner

  const promoKey = "promoBannerShown";
  const now = new Date().getTime();
  const oneHour = 60 * 60 * 1000; // 1 saat
  
  const stored = JSON.parse(localStorage.getItem(promoKey));
  
  if (!stored || now - stored.timestamp > oneHour) {
    Swal.fire({
      imageUrl: "https://cdn.shopify.com/s/files/1/0872/1442/4330/files/actie-baner-4-son.jpg?v=1743800665",
      imageWidth: "auto",
      imageHeight: "auto",
      width: "auto",
      showConfirmButton: false,
      showCloseButton: true,
      background: "transparent",
      customClass: {
        popup: "fullsize-swal",
        closeButton: "custom-swal-close"
      }
    }).then(() => {
      localStorage.setItem(promoKey, JSON.stringify({ shown: true, timestamp: now }));
    });
  
    document.addEventListener("click", function closeListener(e) {
      if (e.target.classList.contains("swal2-close")) {
        localStorage.setItem(promoKey, JSON.stringify({ shown: true, timestamp: now }));
        document.removeEventListener("click", closeListener);
      }
    });
  }


});
